import React from 'react';
import { Box } from '@mui/material';
import TopStepAccountPage, { type AccountPageProps } from './TopStepAccountPage';
import ProfileCDecisionLog from '../components/ProfileCDecisionLog';

const ACCOUNT_ID = 24959632;
const MARKERS = ['573439-88202541', '88202541', 'EXPRESS-V2-DLL-573439-88202541'];

const matchAccount: AccountPageProps['accountMatcher'] = (accounts) => {
  const exact = accounts.find((a) => a.accountId === ACCOUNT_ID);
  if (exact) return exact;
  return accounts.find((a) => MARKERS.some((m) => (a.accountName ?? '').includes(m)));
};

const TopStepExpressFunded2Page: React.FC = () => (
  <Box>
    <TopStepAccountPage
      accountLabel="SF100K Standard Funded"
      accountMatcher={matchAccount}
      challengeParams={{ target: 6000, hardMax: 3500, internalStop: 3000, dailyCap: 1000, accountSize: 100000 }}
      chipLabel="SF100K FUNDED"
      chipColor="#26C6DA"
    />
    <ProfileCDecisionLog
      accountId={ACCOUNT_ID}
      label="SF100K · 24959632"
    />
  </Box>
);

export default TopStepExpressFunded2Page;
